import { render } from "./CommunityButton.vue?vue&type=template&id=f5c9a7b8&ts=true"
import script from "./CommunityButton.vue?vue&type=script&lang=ts"
export * from "./CommunityButton.vue?vue&type=script&lang=ts"

import "./CommunityButton.vue?vue&type=style&index=0&id=f5c9a7b8&scope=true&lang=css"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__